"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTextarea = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const dumblabel_1 = __importDefault(require("../../dumblabel"));
const textArea_1 = __importDefault(require("../../textArea/textArea"));
const constants_1 = require("../../constants");
const status_1 = require("../../constants/status");
class FieldTextarea extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            inputHasFocus: false,
            rows: 3,
            minRows: 3,
            maxRows: 100
        };
        this.id = lodash_uniqueid_1.default('fta_');
        this.handleFocus = e => {
            this.props.onFocus(e);
            this.setState({
                inputHasFocus: true
            });
        };
        this.handleBlur = e => {
            this.props.onBlur(e);
            this.setState({
                inputHasFocus: false
            });
        };
        this.handleChange = e => {
            const { minRows, maxRows } = this.state;
            const textareaLineHeight = constants_1.TEXTAREA_LINE_HEIGHT;
            const previousRows = e.target.rows;
            e.target.rows = minRows; // reset number of rows in textarea
            const currentRows = e.target.scrollHeight / textareaLineHeight;
            if (currentRows === previousRows) {
                e.target.rows = currentRows;
            }
            if (currentRows >= maxRows) {
                e.target.rows = maxRows;
                e.target.scrollTop = e.target.scrollHeight;
            }
            this.setState({
                rows: currentRows < maxRows ? currentRows : maxRows
            });
            this.props.onValueChange(e);
        };
        this.render = () => {
            const { label, placeholder, value, inputRef, disabled, invalid, caution, valid, required, hideLabel, noResize, errorMessage, hideErrorMessage } = this.props;
            const { inputHasFocus, rows } = this.state;
            let status;
            if (invalid) {
                status = status_1.STATUS_INVALID;
            }
            else if (caution) {
                status = status_1.STATUS_CAUTION;
            }
            else if (valid) {
                status = status_1.STATUS_VALID;
            }
            else {
                status = null;
            }
            const labelProps = {
                forId: this.id,
                text: label,
                inputHasValue: !!value,
                inputHasFocus,
                status,
                hideLabel,
                required
            };
            const textAreaProps = {
                type: 'text',
                placeholder,
                id: this.id,
                handleFocus: this.handleFocus,
                handleBlur: this.handleBlur,
                handleChange: this.handleChange,
                value,
                inputRef,
                status,
                disabled,
                rows,
                required,
                noResize,
                errorMessage,
                hideErrorMessage
            };
            return (jsx_runtime_1.jsx(dumblabel_1.default, Object.assign({}, labelProps, { children: jsx_runtime_1.jsx(textArea_1.default, Object.assign({}, textAreaProps), void 0) }), void 0));
        };
    }
}
exports.FieldTextarea = FieldTextarea;
FieldTextarea.propTypes = {
    label: prop_types_1.default.string.isRequired,
    inputRef: prop_types_1.default.func,
    value: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    caution: prop_types_1.default.bool,
    valid: prop_types_1.default.bool,
    hideLabel: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    errorMessage: prop_types_1.default.string,
    noResize: prop_types_1.default.bool,
    onValueChange: prop_types_1.default.func.isRequired,
    onFocus: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
    hideErrorMessage: prop_types_1.default.bool
};
FieldTextarea.defaultProps = {
    inputRef: () => { },
    value: '',
    placeholder: '',
    disabled: false,
    invalid: false,
    caution: false,
    valid: false,
    required: false,
    hideLabel: false,
    errorMessage: '',
    noResize: false,
    onFocus: () => { },
    onBlur: () => { },
    hideErrorMessage: false
};
exports.default = FieldTextarea;
//# sourceMappingURL=index.js.map